export const remapDataToCheckBoxItems = (arr: AccordionRadioItem[] | undefined): AccordionCheckBoxItem[] => {
  if (arr != null && arr?.length > 0) {
    return arr.map((item: AccordionRadioItem) => {
      return { id: item.key, name: item.description };
    });
  }
  return [];
};
